import { createAsyncThunk } from '@reduxjs/toolkit';
import getApiClient from 'js/apiClient';
import { IProduct, IPurchase } from './types';

export const asyncFetchProducts = createAsyncThunk<IProduct[], void>(
    'products/fetchProducts',
    async (_, { rejectWithValue }) => {
        return getApiClient()
            .get('products/')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncFetchPurchases = createAsyncThunk<IPurchase[], void>(
    'products/fetchPurchases',
    async (_, { rejectWithValue }) => {
        return getApiClient()
            .get('purchases/')
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncCreatePurchase = createAsyncThunk<IPurchase, number>(
    'products/createPurchase',
    async (product: number, { rejectWithValue }) => {
        const data = {
            product,
        };
        return getApiClient()
            .post('purchases/', data)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);

export const asyncDeletePurchase = createAsyncThunk<number, IPurchase>(
    'products/deletePurchase',
    async ({ id, product }: IPurchase, { rejectWithValue }) => {
        return getApiClient()
            .delete(`purchases/${id}/`)
            .then(() => {
                return product;
            })
            .catch(error => {
                return rejectWithValue(error.message);
            });
    }
);
